const is_object = function (obj) {
  return typeof obj === "object" && obj !== null && !Array.isArray(obj);
};

export { is_object };
